define('models/EligibilityIssues',[
	'core/can',
	'models/Base',
	'models/Patient'
], function(can, Base, Patient) {
	
	var Issues = {
		PartAB: 'Part A & B',
		Hmo: 'HMO',
		Msp: 'MSP',
		OtherHha: 'Other HHA',
		Hospice: 'Hospice',
		CwfNotFound: 'CWF Not Found'
	};
	
	return Base.extend({
		
		withPatients: function(params, success, error) {
			var me = this;
			return can.ajax({
					type: 'GET',
					url: '/Report/EligibilityIssues',
					data: params
				})
				.then(function(data) {
					for (var key in data) {
						data[key] = {
							Name: Issues[key],
							Patients: new Patient.List(data[key]).filter(function(model) {	
								return (model.attr('HicNumber') !== undefined && model.attr('HicNumber') !== null);
							})
						};
					}
					return me.model(data);
				})
				.then(success, error);
		},
		
		withCount: function(params, success, error) {
			return can.ajax({
					type: 'GET',
					url: '/Report/EligibilityIssuesCount',
					data: params
				}).then(success, error);
		}
		
	},{
		
		_Total: can.compute(function() {
			var total = 0;
			this.each(function(o, key) {
				total += o.attr('Patients.length');
			});
			return total;
		})
		
	});
	
});
